'use client'

import { useLocalStorage } from 'usehooks-ts'

import { useEffect } from 'react'

import { USER_TOKEN_KEY } from './constants'

import { useUserTokenState } from './types'

export default function useUserToken(): useUserTokenState {
    const [userToken, setUserToken] = useLocalStorage<string | null>(USER_TOKEN_KEY, null)

    function generateUUIDv4() {
        const randomBytes = new Uint8Array(16)
        window.crypto.getRandomValues(randomBytes)

        randomBytes[6] = (randomBytes[6] & 0x0f) | 0x40
        randomBytes[8] = (randomBytes[8] & 0x3f) | 0x80

        const hex = Array.from(randomBytes, (byte) => byte.toString(16).padStart(2, '0'))

        return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`
    }

    useEffect(() => {
        if (!userToken || !userToken.includes('-')) {
            setUserToken(location.protocol === 'http:' ? '677b70fa-937d-4469-a812-edaafd36fa42' : generateUUIDv4())
        }
    }, [setUserToken, userToken])

    return [userToken as string, setUserToken]
}
